export const FeatureGamePage = {
  ActionApply: 'Action.Apply',
  LabelSponsoredAd: 'Label.SponsoredAd',
  LabelNoSearchResults: 'LabelNoSearchResults',
  LabelPlayingOnePlusUsersWithComma: 'LabelPlayingOnePlusUsersWithComma',
  LabelPlayingOneUser: 'LabelPlayingOneUser',
  LabelBy: 'LabelCreatorBy',
  LabelByPrefix: 'Label.By'
};

export const CommonGameSorts = {
  LabelApiError: 'Label.ApiError',
  LabelGames: 'Label.Games',
  LabelSponsoredAdsDisclosureStatic: 'Label.SponsoredAdsDisclosureStatic'
};

export const CommonUIFeatures = {
  LabelDiscover: 'Label.Discover',
  LabelCharts: 'Label.Charts',
  ActionClose: 'Action.Close',
  ActionDropdownSelected: 'Action.DropdownSelected',
  ActionDropdownNotSelected: 'Action.DropdownNotSelected'
};

export const FeaturePlacesList = {
  ActionSeeAll: 'Action.SeeAll',
  ActionInterestCatcherContinue: 'Action.InterestCatcherContinue',
  ActionInterestCatcherContinueSelected: 'Action.InterestCatcherContinueSelected',
  ActionInterestCatcherSkip: 'Action.InterestCatcherSkip',
  ActionInterestCatcherInterested: 'Action.InterestCatcherInterested'
};

export const FeatureGameDetails = {
  HeadingDescription: 'Heading.Description',
  LabelAgeGuidelines: 'Label.AgeGuidelines',
  LabelLearnMore: 'Label.LearnMore',
  LabelBy: 'Label.By',
  LabelPlaying: 'Label.Playing',
  LabelFavorites: 'Label.Favorites',
  LabelVisits: 'Label.Visits',
  LabelCreated: 'Label.Created',
  LabelUpdated: 'Label.Updated',
  LabelMaxPlayers: 'Label.MaxPlayers',
  LabelGenre: 'Label.Genre',
  LabelSubgenre: 'Label.Subgenre',
  LabelAllowedGear: 'Label.AllowedGear',
  LabelReportAbuse: 'Label.ReportAbuse',
  LabelPlaceCopyingAllowed: 'Label.PlaceCopyingAllowed',
  LabelVoiceEnabled: 'Label.VoiceEnabled',
  LabelYes: 'Label.Yes',
  LabelNo: 'Label.No',
  LabelUnavailable: 'Label.Unavailable',
  LabelSuitableForEveryone: 'Label.SuitableForEveryone',
  LabelCommunication: 'Label.Communication',
  LabelMicrophone: 'Label.Microphone',
  LabelCamera: 'Label.Camera',
  LabelNone: 'Label.None',
  LabelThankYou: 'Label.ThankYouMessage',
  LabelGenreUnderConstruction: 'Label.GenreUnderConstruction',
  LabelGenreInProgress: 'Label.GenreInProgress',
  HeadingRecommendedGames: 'Heading.RecommendedGames',
  ActionSwapToSource: 'Action.SwapToSource',
  ActionSwapToTranslation: 'Action.SwapToTranslation',
  ActionTranslate: 'Action.Translate'
};

export const FeatureCommunityLinks = {
  HeadingCommunityTitle: 'Heading.CommunityTitle',
  DescriptionCommunityDefault: 'Description.CommunityDefault',
  LabelViewButton: 'Label.ViewButton'
};

export const FeatureGearOptionsDisplay = {
  LabelAllGenreAllowed: 'LabelAllGenreAllowed',
  LabelGearOnly: 'LabelGearOnly',
  LabelNoGear: 'LabelNoGear'
};

export const FeatureGamePass = {
  ActionAddPass: 'Action.AddPass',
  HeadingPassesForThisGame: 'Heading.PassesForThisGame',
  LabelBuy: 'Label.Buy',
  LabelOwned: 'Label.Owned',
  LabelNoPasses: 'Label.NoPasses'
};

export const FeatureSocialShare = {
  LabelInviteExpiredError: 'Label.InviteExpiredError',
  LabelInviterNotHereError: 'Label.InviterNotHereError',
  DescriptionInviteExpiredError: 'Description.InviteExpiredError',
  DescriptionInviterNotHereError: 'Description.InviterNotHereError',
  LabelCancel: 'Label.Cancel',
  LabelPlay: 'Label.Play'
};

export default {
  CommonGameSorts,
  CommonUIFeatures,
  FeatureGameDetails,
  FeatureGamePage,
  FeatureGamePass,
  FeatureGearOptionsDisplay,
  FeaturePlacesList,
  FeatureSocialShare,
  FeatureCommunityLinks
};
